
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

  export function checkBrowserSupport() {
    const supports = {
      cssGrid: CSS.supports('display', 'grid'),
      cssVariables: CSS.supports('color', 'var(--test)'),
      flexbox: CSS.supports('display', 'flex'),
      transform: CSS.supports('transform', 'translateX(0)')
    };
    
    if (!supports.cssGrid) {
      document.documentElement.classList.add('no-grid-support');
    }
    if (!supports.cssVariables) {
      document.documentElement.classList.add('no-css-variables');
    }
    
    return supports;
  }

  function isLowPerformanceDevice() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const memory = navigator.deviceMemory || 4;
    const cores = navigator.hardwareConcurrency || 4;
    
    // Не отключаем анимации на всех мобильных, только на действительно слабых
    return (isMobile && (memory < 2 || cores < 2)) || memory < 2;
  }

  const PERFORMANCE_CONFIG = {
    lowPerf: {
      magnetic: false,
      ripple: false,
      wave: false,
      stagger: 0.02,
      animationDuration: 0.3
    },
    mobilePerf: {
      magnetic: false,
      ripple: false,
      wave: true,
      stagger: 0.015,
      animationDuration: 0.35
    },
    highPerf: {
      magnetic: true,
      ripple: true,
      wave: true,
      stagger: 0.008,
      animationDuration: 0.4
    }
  };

  export function initWithPerformanceProfile() {
    const isLowPerf = isLowPerformanceDevice();
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    let config;
    if (isLowPerf) {
      config = PERFORMANCE_CONFIG.lowPerf;
      document.documentElement.classList.add('low-performance');
    } else if (isMobile) {
      config = PERFORMANCE_CONFIG.mobilePerf;
      document.documentElement.classList.add('mobile-performance');
    } else {
      config = PERFORMANCE_CONFIG.highPerf;
    }
    if(LOGO_CONFIG) {
      LOGO_CONFIG.magnetic.enabled = config.magnetic;
      LOGO_CONFIG.ripple.enabled = config.ripple;
      LOGO_CONFIG.animation.stagger = config.stagger;
    }
    if(ENGAGEMENT_CONFIG) {
      ENGAGEMENT_CONFIG.wave.enabled = config.wave;
      ENGAGEMENT_CONFIG.magnetic.enabled = config.magnetic;
    }
  }

  // ====== REDUCED MOTION ======
  export function handleReducedMotion() {
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const motionToggle = document.getElementById('motion-toggle');
    const classEnabled = 'enabled';

    function updateMotionPreference(e) {
      const prefersReducedMotion = e.matches;
      
      if (prefersReducedMotion) {
        document.documentElement.classList.add('no-motion');
        LOGO_CONFIG.magnetic.enabled = false;
        LOGO_CONFIG.ripple.enabled = false;
        ENGAGEMENT_CONFIG.wave.enabled = false;
        ENGAGEMENT_CONFIG.magnetic.enabled = false;
        
        engagementGrids.forEach(state => {
          if (state.waveTimeline) state.waveTimeline.kill();
        });
        
        if (waveAnimation) waveAnimation.kill();
        
        if (motionToggle) {
          motionToggle.classList.add(classEnabled);
        }
      }
    }
    
    updateMotionPreference(reducedMotionQuery);
    reducedMotionQuery.addEventListener('change', updateMotionPreference);
    
    if (motionToggle) {
      motionToggle.addEventListener('click', () => {
        const hasNoMotion = document.documentElement.classList.toggle('no-motion');
        if (hasNoMotion) {
          motionToggle.classList.add(classEnabled);
        } else {
          motionToggle.classList.remove(classEnabled);

        }
        
        if (hasNoMotion) {
          console.log(LOGO_CONFIG)
          if(LOGO_CONFIG) {
            LOGO_CONFIG.magnetic.enabled = false;
            LOGO_CONFIG.ripple.enabled = false;
          }
          if(ENGAGEMENT_CONFIG) {
            ENGAGEMENT_CONFIG.wave.enabled = false;
          }
          engagementGrids.forEach(state => {
            if (state.waveTimeline) state.waveTimeline.kill();
          });
        } else {
          // Восстанавливаем настройки производительности
          const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
          const config = isMobile ? PERFORMANCE_CONFIG.mobilePerf : PERFORMANCE_CONFIG.highPerf;
          
          if(LOGO_CONFIG) {
            LOGO_CONFIG.magnetic.enabled = config.magnetic;
            LOGO_CONFIG.ripple.enabled = config.ripple;
          }
          if(ENGAGEMENT_CONFIG) {
            ENGAGEMENT_CONFIG.wave.enabled = config.wave;
            startEngagementWaveAnimations();
          }
        }
        
        localStorage.setItem('prefers-reduced-motion', hasNoMotion);
      });
      
      const userPrefersReduced = localStorage.getItem('prefers-reduced-motion');
      if (userPrefersReduced === 'true') {
        document.documentElement.classList.add('no-motion');
        motionToggle.classList.add(classEnabled);
      }
    }
  }

  // ====== ACCESSIBILITY ======
  export function enhanceAccessibility() {
    const grid = document.getElementById('logo-grid');
    const progressBar = document.getElementById('progress-bar');
    if(grid) {
      grid.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const firstCoreCircle = logoCircles.find(circle => 
            circle.dataset.isLogo === 'true'
          );
          if (firstCoreCircle) {
            handleLogoEnter(firstCoreCircle, parseInt(firstCoreCircle.dataset.index));
          }
        }
      });
    }
    
    function updateProgressBarAccessibility(progress) {
      if (!progressBar) return;
      
      progressBar.setAttribute('aria-valuenow', Math.round(progress));
      
      const phase = paintingState.phase;
      const message = {
        'red': `Раскрашено красным: ${Math.round(progress)}%`,
        'black': `Раскрашено черным: ${Math.round(progress)}%`, 
        'original': `Возврат к исходному: ${Math.round(progress)}%`
      }[phase];
      
      progressBar.setAttribute('aria-valuetext', message);
    }
    
    const originalUpdateProgress = updateProgress;
    updateProgress = function() {
      originalUpdateProgress();
      const progress = (paintingState.paintedRed.size / LOGO_CORE.length) * 100;
      updateProgressBarAccessibility(progress);
    };
  }

  // ====== ЛОГОТИП С ПРОГРЕСС-БАРОМ ======
  const LOGO_CONFIG = {
    grid: {
      columns: 8,
      rows: 7
    },
    animation: {
      appearDuration: 0.4,
      stagger: 0.008,
      ease: "power2.out",
      waveDelay: 5000
    },
    magnetic: {
      enabled: true,
      distanceFactor: 1.2,
      offsetFactor: 0.025,
      duration: 0.6,
      ease: "power2.out"
    },
    ripple: {
      enabled: true,
      maxDistance: 4,
      delayStep: 0.01,
      duration: 0.3,
      scaleBoost: 0,
      magneticBoost: 0.3,
      ease: "power2.out"
    },
    painting: {
      enabled: true,
      paintDuration: 0.15,
      paintEase: "power2.out"
    }
  };

  const LOGO_CORE = [
    [6, 0],
    [5, 0], [5, 7],
    [4, 0], [4, 4], [4, 5], [4, 7],
    [3, 0], [3, 3], [3, 6], [3, 7],
    [2, 0], [2, 2], [2, 5], [2, 6], [2, 7],
    [1, 0], [1, 1],
    [0, 0]
  ];

  const BELOW_FILL = [[2, 1]];
  const ABOVE_NOFILL = [[3, 4], [3, 5]];

  // Предвычисление данных для оптимизации
  const LOGO_DATA_MAP = new Map();
  LOGO_CORE.forEach(([row, col]) => {
    const index = row * LOGO_CONFIG.grid.columns + col;
    LOGO_DATA_MAP.set(index, { isCore: true });
  });

  let logoCircles = [];
  let hoveredIndex = null;
  let waveAnimation;
  let isMouseInGrid = false;
  let isTouchDevice = false;
  let waveTimeout = null;
  let touchMoveActive = false;
  let magneticThrottle = null;
  
  let paintingState = {
    phase: 'red',
    paintedRed: new Set(),
    paintedBlack: new Set()
  };

  export function initLogoGrid() {
    const grid = document.getElementById('logo-grid');
    const total = LOGO_CONFIG.grid.columns * LOGO_CONFIG.grid.rows;
    
    isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    for (let i = 0; i < total; i++) {
      const circle = document.createElement('div');
      circle.className = 'circle';
      circle.dataset.index = i;
      
      const row = Math.floor(i / LOGO_CONFIG.grid.columns);
      const col = i % LOGO_CONFIG.grid.columns;
      circle.dataset.row = row;
      circle.dataset.col = col;
      
      const isLogoCore = LOGO_DATA_MAP.has(i);
      circle.dataset.isLogo = isLogoCore;
      
      grid.appendChild(circle);
      logoCircles.push(circle);
    }

    initLogoInteractivity();
    animateDiagonalWaveAppearance();
    updateProgress();
  }

  function initLogoInteractivity() {
    const grid = document.getElementById('logo-grid');
    
    logoCircles.forEach((circle, index) => {
      circle.addEventListener('mouseenter', () => handleLogoEnter(circle, index));
      circle.addEventListener('mouseleave', () => handleLogoLeave(circle, index));
      
      circle.addEventListener('touchstart', (e) => {
        e.preventDefault();
        handleLogoEnter(circle, index);
      });

      circle.addEventListener('touchend', (e) => {
        e.preventDefault();
      });
    });

    function createOptimizedTouchHandler() {
      let lastTouchTime = 0;
      return function(e) {
        const now = Date.now();
        if (now - lastTouchTime < 16) return;
        lastTouchTime = now;
        
        e.preventDefault();
        touchMoveActive = true;
        
        const touch = e.touches[0];
        const rect = grid.getBoundingClientRect();
        
        const touchX = touch.clientX - rect.left;
        const touchY = touch.clientY - rect.top;
        
        logoCircles.forEach((circle, index) => {
          const circleRect = circle.getBoundingClientRect();
          const circleX = circleRect.left + circleRect.width / 2 - rect.left;
          const circleY = circleRect.top + circleRect.height / 2 - rect.top;
          
          const distance = Math.sqrt(
            Math.pow(touchX - circleX, 2) + 
            Math.pow(touchY - circleY, 2)
          );
          
          if (distance < parseFloat(getComputedStyle(circle).width) * 0.8 && 
              circle.dataset.isLogo === 'true') {
            handleLogoEnter(circle, index);
          }
        });
      };
    }

    grid.addEventListener('touchmove', createOptimizedTouchHandler());

    grid.addEventListener('touchend', () => {
      touchMoveActive = false;
    });

    grid.addEventListener('mouseenter', () => {
      isMouseInGrid = true;
      cancelWaveAnimation();
      clearTimeout(waveTimeout);
    });

    grid.addEventListener('mouseleave', () => {
      isMouseInGrid = false;
      waveTimeout = setTimeout(() => {
        if (!isMouseInGrid) {
          startWaveAnimation();
        }
      }, LOGO_CONFIG.animation.waveDelay);
    });

    grid.addEventListener('touchstart', () => {
      isMouseInGrid = true;
      cancelWaveAnimation();
      clearTimeout(waveTimeout);
    });

    grid.addEventListener('touchend', () => {
      isMouseInGrid = false;
      waveTimeout = setTimeout(() => {
        if (!isMouseInGrid) {
          startWaveAnimation();
        }
      }, LOGO_CONFIG.animation.waveDelay);
    });

    if (LOGO_CONFIG.magnetic.enabled && !isTouchDevice) {
      grid.addEventListener('mousemove', handleLogoMagneticMove);
      grid.addEventListener('mouseleave', resetLogoMagnetic);
    }
  }

  function handleLogoEnter(circle, index) {

    if (LOGO_CONFIG.ripple.enabled && !isTouchDevice) {
      rippleFrom(index);
    }
    
    if (LOGO_CONFIG.painting.enabled && circle.dataset.isLogo === 'true') {
      requestAnimationFrame(() => {
        paintCircle(circle, index);
      });
    }
  }

  function handleLogoLeave(circle, index) {
    if (hoveredIndex === index) hoveredIndex = null;
  }

  function animateDiagonalWaveAppearance() {
    gsap.set(logoCircles, { 
      opacity: 0, 
      scale: 0.9,
      x: 20,
      y: 20
    });

    logoCircles.forEach((circle, index) => {
      const row = Math.floor(index / LOGO_CONFIG.grid.columns);
      const col = index % LOGO_CONFIG.grid.columns;
      
      const isCore = LOGO_DATA_MAP.has(index);
      const isBelow = BELOW_FILL.some(([r, c]) => r === row && c === col);
      const isAboveNoFill = ABOVE_NOFILL.some(([r, c]) => r === row && c === col);
      
      if (isCore) {
        circle.classList.add('core');
      } else if (isBelow) {
        circle.classList.add('below');
      } else if (isAboveNoFill) {
        circle.classList.add('above');
      } else if (row < 3) {
        circle.classList.add('above');
      } else {
        circle.classList.add('below');
      }
    });

    gsap.to(logoCircles, {
      opacity: 1,
      scale: 1,
      x: 0,
      y: 0,
      duration: LOGO_CONFIG.animation.appearDuration,
      stagger: {
        each: LOGO_CONFIG.animation.stagger,
        from: "random"
      },
      ease: LOGO_CONFIG.animation.ease,
      onComplete: () => {
        waveTimeout = setTimeout(() => {
          if (!isMouseInGrid) {
            startWaveAnimation();
          }
        }, LOGO_CONFIG.animation.waveDelay);
      }
    });
  }

  function startWaveAnimation() {
    if (isMouseInGrid || document.documentElement.classList.contains('no-motion')) return;

    const coreCircles = logoCircles.filter((circle, index) => {
      return LOGO_DATA_MAP.has(index);
    });

    const columns = {};
    coreCircles.forEach(circle => {
      const col = parseInt(circle.dataset.col);
      if (!columns[col]) columns[col] = [];
      columns[col].push(circle);
    });

    if (waveAnimation) {
      waveAnimation.kill();
    }

    waveAnimation = gsap.timeline({ 
      repeat: 1,
      onComplete: () => {
        if (!isMouseInGrid) {
          waveTimeout = setTimeout(() => {
            if (!isMouseInGrid) {
              startWaveAnimation();
            }
          }, LOGO_CONFIG.animation.waveDelay);
        }
      }
    });
    
    const sortedCols = Object.keys(columns).sort((a, b) => a - b);
    
    const firstColumn = columns[sortedCols[0]];
    if (firstColumn) {
      const sortedFirstColumn = [...firstColumn].sort((a, b) => 
        parseInt(b.dataset.row) - parseInt(a.dataset.row)
      );
      
      waveAnimation.to(sortedFirstColumn, {
        scale: 1.08,
        duration: 0.08,
        stagger: 0.05,
        ease: "power2.out",
        yoyo: true,
        repeat: 1
      }, 0);
    }

    sortedCols.forEach((col, index) => {
      if (index === 0) return;
      
      waveAnimation.to(columns[col], {
        scale: 1.08,
        duration: 0.08,
        ease: "power2.out",
        yoyo: true,
        repeat: 1
      }, index * 0.1);
    });
  }

  function stopWaveAnimation() {
    if (waveAnimation) {
      waveAnimation.kill();
      waveAnimation = null;
    }
    clearTimeout(waveTimeout);
  }

  function cancelWaveAnimation() {
    if (waveAnimation) {
      waveAnimation.kill();
      waveAnimation = null;
      
      gsap.to(logoCircles, {
        scale: 1,
        duration: 0.2,
        ease: "power2.out",
        overwrite: true
      });
    }
    clearTimeout(waveTimeout);
  }

  function paintCircle(circle, index) {
    const { phase, paintedRed, paintedBlack } = paintingState;
    
    if (phase === 'red' && !paintedRed.has(index)) {
      paintedRed.add(index);
      gsap.to(circle, {
        backgroundColor: '#FF0037',
        borderColor: '#FF0037',
        duration: LOGO_CONFIG.painting.paintDuration,
        ease: LOGO_CONFIG.painting.paintEase,
        onComplete: () => {
          circle.classList.add('painted-red');
          circle.classList.remove('painted-black');
          checkPhaseCompletion();
          updateProgress();
        }
      });
    } else if (phase === 'black' && paintedRed.has(index) && !paintedBlack.has(index)) {
      paintedBlack.add(index);
      gsap.to(circle, {
        backgroundColor: '#111111',
        borderColor: '#111111',
        duration: LOGO_CONFIG.painting.paintDuration,
        ease: LOGO_CONFIG.painting.paintEase,
        onComplete: () => {
          circle.classList.add('painted-black');
          circle.classList.remove('painted-red');
          checkPhaseCompletion();
          updateProgress();
        }
      });
    } else if (phase === 'original' && paintedBlack.has(index)) {
      paintedBlack.delete(index);
      paintedRed.delete(index);
      
      const isCore = circle.classList.contains('core');
      const isBelow = circle.classList.contains('below');
      
      let targetBg, targetBorder;
      
      if (isCore) {
        targetBg = 'rgba(255, 0, 55, 0.15)';
        targetBorder = 'rgba(255, 0, 55, 0.2)';
      } else if (isBelow) {
        targetBg = 'transparent';
        targetBorder = 'rgba(255, 0, 55, 0.2)';
      } else {
        targetBg = 'transparent';
        targetBorder = 'rgba(255, 0, 55, 0.11)';
      }
      
      gsap.to(circle, {
        backgroundColor: targetBg,
        borderColor: targetBorder,
        duration: LOGO_CONFIG.painting.paintDuration,
        ease: LOGO_CONFIG.painting.paintEase,
        onComplete: () => {
          circle.classList.remove('painted-red', 'painted-black');
          checkPhaseCompletion();
          updateProgress();
        }
      });
    }
  }

  function checkPhaseCompletion() {
    const { phase, paintedRed, paintedBlack } = paintingState;
    const totalLogoCircles = LOGO_CORE.length;
    
    if (phase === 'red' && paintedRed.size === totalLogoCircles) {
      paintingState.phase = 'black';
      updateProgressBarColor();
    } else if (phase === 'black' && paintedBlack.size === totalLogoCircles) {
      paintingState.phase = 'original';
      updateProgressBarColor();
    } else if (phase === 'original' && paintedBlack.size === 0 && paintedRed.size === 0) {
      paintingState.phase = 'red';
      updateProgressBarColor();
    }
  }

  function updateProgress() {
    const { phase, paintedRed, paintedBlack } = paintingState;
    const totalLogoCircles = LOGO_CORE.length;
    let progress = 0;
    
    if (phase === 'red') {
      progress = (paintedRed.size / totalLogoCircles) * 100;
    } else if (phase === 'black') {
      progress = (paintedBlack.size / totalLogoCircles) * 100;
    } else if (phase === 'original') {
      progress = ((totalLogoCircles - paintedBlack.size) / totalLogoCircles) * 100;
    }
    
    const progressBar = document.getElementById('progress-bar');
    
    gsap.to(progressBar, {
      width: `${progress}%`,
      duration: 0.5,
      ease: "power2.out"
    });
  }

  function updateProgressBarColor() {
    const progressBar = document.getElementById('progress-bar');
    const { phase } = paintingState;
    
    switch (phase) {
      case 'red':
        progressBar.style.background = '#FF0037';
        break;
      case 'black':
        progressBar.style.background = '#FF0037';
        break;
      case 'original':
        progressBar.style.background = '#FF0037';
        break;
    }
  }
  function getComputedCssVarPx(varName) {
    const el = document.createElement("div");
    el.style.position = "absolute";
    el.style.visibility = "hidden";
    el.style.width = `var(${varName})`;
    document.body.appendChild(el);

    const px = el.offsetWidth;

    el.remove();
    return px;
}
  function rippleFrom(originIndex) {
    if (isTouchDevice || document.documentElement.classList.contains('no-motion')) return;
    const maxDist = LOGO_CONFIG.ripple.maxDistance;
    const delayStep = LOGO_CONFIG.ripple.delayStep;
    const circleSizePx = getComputedCssVarPx('--circle-size');
    logoCircles.forEach((circle, i) => {
      const row = parseInt(circle.dataset.row);
      const col = parseInt(circle.dataset.col);
      
      const originCircle = logoCircles[originIndex];
      const oRow = parseInt(originCircle.dataset.row);
      const oCol = parseInt(originCircle.dataset.col);
      const dist = Math.abs(row - oRow) + Math.abs(col - oCol);
      
      if (dist === 0 || dist > maxDist) return;
      const delay = delayStep * dist;
      const strength = (maxDist - dist + 1) / maxDist;
      
      const dx = (col - oCol) * circleSizePx * LOGO_CONFIG.ripple.magneticBoost * strength;
      const dy = (row - oRow) * circleSizePx * LOGO_CONFIG.ripple.magneticBoost * strength;

      gsap.to(circle, {
        x: dx,
        y: dy,
        duration: LOGO_CONFIG.ripple.duration,
        delay,
        ease: LOGO_CONFIG.ripple.ease,
        yoyo: true,
        repeat: 1,
        onComplete: () => {
          gsap.to(circle, {
            x: 0,
            y: 0,
            duration: 0.15,
            ease: "power2.out"
          });
        }
      });
    });
  }

  function handleLogoMagneticMove(event) {
    if (isTouchDevice || document.documentElement.classList.contains('no-motion') || magneticThrottle) return;
    
    magneticThrottle = setTimeout(() => {
      magneticThrottle = null;
      
      const grid = document.getElementById('logo-grid');
      const rect = grid.getBoundingClientRect();
      
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;
      
      const { distanceFactor, offsetFactor, duration, ease } = LOGO_CONFIG.magnetic;
      const circleSizePx = getComputedCssVarPx('--circle-size');
      
      const maxDistance = circleSizePx * 5 * distanceFactor;
      const maxOffset = circleSizePx * offsetFactor * 3;
      
      logoCircles.forEach((circle) => {
        const circleRect = circle.getBoundingClientRect();
        const cx = circleRect.left + circleRect.width / 2 - rect.left;
        const cy = circleRect.top + circleRect.height / 2 - rect.top;
        
        const dx = cx - mouseX;
        const dy = cy - mouseY;
        const dist = Math.sqrt(dx * dx + dy * dy);
        
        if (dist > maxDistance) {
          gsap.to(circle, {
            x: 0,
            y: 0,
            duration: duration * 0.5,
            ease: "power2.out",
            overwrite: "auto"
          });
          return;
        }
        
        const force = (maxDistance - dist) / maxDistance;
        const normX = dx / dist;
        const normY = dy / dist;
        
        const offsetX = normX * force * maxOffset;
        const offsetY = normY * force * maxOffset;
        
        gsap.to(circle, {
          x: offsetX,
          y: offsetY,
          duration,
          ease,
          overwrite: "auto"
        });
      });
    }, 16);
  }

  function resetLogoMagnetic() {
    if (isTouchDevice) return;
    
    logoCircles.forEach((circle) => {
      gsap.to(circle, {
        x: 0,
        y: 0,
        duration: 0.3,
        ease: "power2.out",
        overwrite: "auto"
      });
    });
  }

  // ====== ENGAGEMENT FORMATS ======
  const ENGAGEMENT_CONFIG = {
    base: {
      activeScale: 1.12,
      colorDefault: "transparent",
      colorActive: "#FF0037",
      borderDefault: "rgba(255,0,55,0.11)",
      borderStrong: "rgba(255,0,55,0.35)",
      hoverInDuration: 0.2,
      hoverOutDuration: 0.22
    },
    ripple: {
      enabled: false,
      maxDistance: 3,
      delayStep: 0.02,
      duration: 0.4,
      scaleBoost: 0.1,
      magneticBoost: 0.05,
      ease: "power2.out",
      color: "rgba(255,0,55,0.11)",
      opacityBoost: 0.3,
      yoyo: true,
      repeat: 1
    },
    magnetic: {
      enabled: true,
      maxDistanceRatio: 0.5,
      maxOffset: 4,
      duration: 0.35
    },
    wave: {
      enabled: true,
      interval: 4.0,
      duration: 0.5,
      waveHeight: 2,
      intensity: 0.8
    }
  };

  const engagementGrids = [];

  export function initAllEngagementGrids(circles) {
    circles.forEach((gridEl) => {
      const cols = parseInt(gridEl.dataset.cols, 10) || 7;
      const rows = parseInt(gridEl.dataset.rows, 10) || 7;
      const pattern = gridEl.dataset.pattern || "plain";

      const state = {
        el: gridEl,
        wrapper: gridEl.closest(".circles-wrapper"),
        cols,
        rows,
        pattern,
        circles: [],
        waveTimeline: null,
        appearTimeline: null,
        mouseInside: false
      };

      buildEngagementGrid(state);
      applyEngagementPattern(state);
      setupEngagementInteractions(state);

      engagementGrids.push(state);
    });

    // Принудительный запуск волн после небольшой задержки
    setTimeout(() => {
      startEngagementWaveAnimations();
    }, 1000);

    initEngagementAppearAnimations();
  }

  function buildEngagementGrid(state) {
    const { el, cols, rows } = state;
    el.innerHTML = "";
    state.circles = [];

    el.style.gridTemplateColumns = `repeat(${cols}, var(--dot-size))`;
    el.style.gridAutoRows = `var(--dot-size)`;

    const total = cols * rows;

    for (let i = 0; i < total; i++) {
      const dot = document.createElement("div");
      dot.className = "circle-dot";
      const row = Math.floor(i / cols);
      const col = i % cols;
      dot.dataset.row = row;
      dot.dataset.col = col;
      el.appendChild(dot);
      state.circles.push(dot);
    }
  }

  function getDotVisualState(dot) {
    const { base } = ENGAGEMENT_CONFIG;
    const isFilled = dot.classList.contains("is-filled");
    const isActive = dot.classList.contains("is-active");
    const isStrong = dot.classList.contains("is-strong");
    const isDashes = dot.classList.contains("is-dashed");

    const border = isFilled || isStrong
      ? base.borderStrong
      : ((isActive && !isDashes) ? "rgba(255,0,55,0.35)" : base.borderDefault);

    const opacity = isFilled || isActive || isStrong ? 1 : 1;

    return {
      backgroundColor: isFilled ? "rgba(255,0,55,0.18)" : base.colorDefault,
      borderColor: border,
      opacity
    };
  }

  function applyEngagementPattern(state) {
    const { pattern, circles, cols, rows } = state;
    const centerRow = (rows - 1) / 2;
    const centerCol = (cols - 1) / 2;
    const maxRow = rows - 1;

    circles.forEach(dot => {
      dot.className = "circle-dot";
    });

    /* Consulting — speech bubble шире */
    if (pattern === "consulting-grid") {
      circles.forEach((dot) => {
        const r = Number(dot.dataset.row);
        const c = Number(dot.dataset.col);

        const inRect = r >= 1 && r <= 4 && c >= 1 && c <= 5;
        const isBorder = inRect && (r === 1 || r === 4 || c === 1 || c === 5);

        if (isBorder) {
          dot.classList.add("is-active");
          if ((r === 1 && (c === 2 || c === 4)) || (r === 4 && (c === 3 || c === 4))) {
            dot.classList.add("is-strong");
          }
          if (r === 1 && (c === 1 || c === 5)) {
            dot.classList.add("is-dashed");
          }
        }

        if ((r === 2 || r === 3) && (c === 2 || c === 3 || c === 4)) {
          dot.classList.add("is-filled");
        }

        if ((r === 5 && c === 2) || (r === 5 && c === 3) || (r === 6 && c === 2)) {
          dot.classList.add("is-active");
          if (r === 5 && c === 2) dot.classList.add("is-strong");
        }
      });
    }

    /* Full Strategy — симметричная система с ядром */
    if (pattern === "full-strategy-grid") {
      circles.forEach((dot) => {
        const r = Number(dot.dataset.row);
        const c = Number(dot.dataset.col);

        if (r === centerRow || c === centerCol) {
          dot.classList.add("is-active");
          if (r === centerRow && c === centerCol) {
            dot.classList.add("is-filled", "is-strong");
          }
        }

        if (Math.abs(r - c) === 0 || Math.abs(r + c - maxRow) === 0) {
          dot.classList.add("is-active", "is-dashed");
        }

        if ((r === 0 || r === maxRow) && (c === 0 || c === maxRow)) {
          dot.classList.add("is-strong");
        }

        if (r >= 2 && r <= 4 && c >= 2 && c <= 4) {
          const isBorder = (r === 2 || r === 4 || c === 2 || c === 4);
          if (isBorder) dot.classList.add("is-filled");
        }
      });
    }

    /* Ongoing Partnership — УСИЛЕННЫЕ УГЛОВЫЕ УЗЛЫ */
    if (pattern === "ongoing-partnership-grid") {
      circles.forEach((dot) => {
        const r = Number(dot.dataset.row);
        const c = Number(dot.dataset.col);

        if (r >= 2 && r <= 4 && c >= 2 && c <= 4) {
          const isBorder = (r === 2 || r === 4 || c === 2 || c === 4);
          if (isBorder) {
            dot.classList.add("is-active");
          }
          if (r === 3 && c === 3) {
            dot.classList.add("is-filled", "is-strong");
          }
        }

        const tl = (r === 0 || r === 1) && (c === 1 || c === 2);
        const tr = (r === 0 || r === 1) && (c === 4 || c === 5);
        const bl = (r === 5 || r === 6) && (c === 1 || c === 2);
        const br = (r === 5 || r === 6) && (c === 4 || c === 5);

        if (tl || tr || bl || br) {
          dot.classList.add("is-filled");
          if ((r === 1 && (c === 1 || c === 5)) || (r === 5 && (c === 1 || c === 5))) {
            dot.classList.add("is-strong");
          }
        }

        if ((r === 0 && c === 0) || (r === 0 && c === cols - 1) ||
            (r === rows - 1 && c === 0) || (r === rows - 1 && c === cols - 1)) {
          dot.classList.add("is-active", "is-strong");
        }

        const keyConnections = [
          [1,3], [5,3],
          [3,1], [3,5]
        ];

        if (keyConnections.some(([pr, pc]) => pr === r && pc === c)) {
          dot.classList.add("is-active", "is-dashed");
        }
      });
    }

    /* Smart Speed — элегантная стрелка вправо */
    if (pattern === "smart-speed-grid") {
      const arrowLine = [
        [3,1], [3,2], [3,3]
      ];

      const arrowHead = [
        [2,4], [3,4], [4,4],
        [1,3], [5,3],
        [3,5]
      ];

      const speedLines = [
        [1,1], [2,1], [4,1], [5,1],
        [1,2], [5,2]
      ];

      circles.forEach((dot) => {
        const r = Number(dot.dataset.row);
        const c = Number(dot.dataset.col);

        if (arrowLine.some(([pr, pc]) => pr === r && pc === c)) {
          dot.classList.add("is-filled");
        }

        if (arrowHead.some(([pr, pc]) => pr === r && pc === c)) {
          dot.classList.add("is-filled", "is-strong");
        }

        if (speedLines.some(([pr, pc]) => pr === r && pc === c)) {
          dot.classList.add("is-active", "is-dashed");
        }
      });
    }

    /* Growth — УЛУЧШЕННЫЙ ГОРНЫЙ ГРАФИК */
    if (pattern === "growth-grid") {
      const growthLine = [
        [6,1], [5,1], [4,1], [3,1], [2,1],
        [1,2], [0,3],
        [1,4], [2,3], [1,2],
        [2,5], [1,6], [0,6]
      ];

      const peaks = [
        [0,3], [1,2], [0,6]
      ];

      circles.forEach((dot) => {
        const r = Number(dot.dataset.row);
        const c = Number(dot.dataset.col);

        const isOnLine = growthLine.some(([pr, pc]) => pr === r && pc === c);
        
        let isUnderLine = false;
        for (let linePoint of growthLine) {
          const [lineR, lineC] = linePoint;
          if (c === lineC && r >= lineR) {
            isUnderLine = true;
            break;
          }
        }

        if (isOnLine) {
          dot.classList.add("is-filled");
          if (peaks.some(([pr, pc]) => pr === r && pc === c)) {
            dot.classList.add("is-strong");
          }
        } else if (isUnderLine) {
          dot.classList.add("is-active");
        }
      });
    }

    /* Strategy Pillar - УСЛОЖНЕННАЯ ШЕСТЕРЕНКА С СИСТЕМОЙ */
    if (pattern === "strategy-pillar-grid") {
      const gearCore = [
        [2,2], [2,3], [2,4],
        [3,2], [3,3], [3,4], 
        [4,2], [4,3], [4,4],
        [0,3], [1,1], [1,5], [3,0], [3,6], [5,1], [5,5], [6,3]
      ];

      const gearConnections = [
        [1,2], [1,4], [2,1], [2,5], [4,1], [4,5], [5,2], [5,4],
        [0,1], [0,5], [1,0], [1,6], [5,0], [5,6], [6,1], [6,5]
      ];

      circles.forEach((dot) => {
        const r = Number(dot.dataset.row);
        const c = Number(dot.dataset.col);

        if (gearCore.some(([pr, pc]) => pr === r && pc === c)) {
          dot.classList.add("is-filled");
          if (r === 3 && c === 3) {
            dot.classList.add("is-strong");
          }
          if ((r === 0 && c === 3) || (r === 6 && c === 3) || 
              (r === 3 && c === 0) || (r === 3 && c === 6)) {
            dot.classList.add("is-strong");
          }
        }

        if (gearConnections.some(([pr, pc]) => pr === r && pc === c)) {
          dot.classList.add("is-active");
          if ((r === 0 && c === 1) || (r === 0 && c === 5) || 
              (r === 6 && c === 1) || (r === 6 && c === 5)) {
            dot.classList.add("is-dashed");
          }
        }
      });
    }

    /* Meaning Pillar - ВОЛНЫ КОММУНИКАЦИИ С РЕЗОНАНСОМ */
    if (pattern === "meaning-pillar-grid") {
      const wavePrimary = [
        [3,0], [3,1], [3,2], [3,3], [3,4], [3,5], [3,6],
        [1,1], [1,2], [1,3], [1,4], [1,5],
        [5,1], [5,2], [5,3], [5,4], [5,5]
      ];

      const waveResonance = [
        [0,3], [2,1], [2,5], [4,1], [4,5], [6,3],
        [2,3], [4,3]
      ];

      circles.forEach((dot) => {
        const r = Number(dot.dataset.row);
        const c = Number(dot.dataset.col);

        if (wavePrimary.some(([pr, pc]) => pr === r && pc === c)) {
          dot.classList.add("is-filled");
          if (r === 3 && (c === 0 || c === 3 || c === 6)) {
            dot.classList.add("is-strong");
          }
        }

        if (waveResonance.some(([pr, pc]) => pr === r && pc === c)) {
          dot.classList.add("is-active");
          if ((r === 0 && c === 3) || (r === 6 && c === 3)) {
            dot.classList.add("is-strong", "is-dashed");
          }
          if ((r === 2 && c === 3) || (r === 4 && c === 3)) {
            dot.classList.add("is-dashed");
          }
        }
      });
    }

    /* Growth Pillar - СИСТЕМА РОСТА С КАНАЛАМИ */
    if (pattern === "growth-pillar-grid") {
      const growthCore = [
        [6,2], [6,3], [6,4],
        [5,1], [5,2], [5,3], [5,4], [5,5],
        [4,3], [3,3], [2,3],
        [1,2], [1,3], [1,4],
        [0,3]
      ];

      const growthChannels = [
        [4,1], [4,5], [3,1], [3,5], [2,1], [2,5],
        [1,1], [1,5], [0,1], [0,5]
      ];

      const growthMetrics = [
        [5,0], [5,6], [3,0], [3,6], [1,0], [1,6]
      ];

      circles.forEach((dot) => {
        const r = Number(dot.dataset.row);
        const c = Number(dot.dataset.col);

        if (growthCore.some(([pr, pc]) => pr === r && pc === c)) {
          dot.classList.add("is-filled");
          if (r === 0 && c === 3) {
            dot.classList.add("is-strong");
          }
          if (r === 6 && c === 3) {
            dot.classList.add("is-strong");
          }
        }

        if (growthChannels.some(([pr, pc]) => pr === r && pc === c)) {
          dot.classList.add("is-active");
          if ((r === 4 && c === 1) || (r === 4 && c === 5)) {
            dot.classList.add("is-dashed");
          }
        }

        if (growthMetrics.some(([pr, pc]) => pr === r && pc === c)) {
          dot.classList.add("is-active");
          if ((r === 5 && c === 0) || (r === 5 && c === 6)) {
            dot.classList.add("is-strong", "is-dashed");
          }
        }
      });
    }

    circles.forEach(dot => {
      const visual = getDotVisualState(dot);
      gsap.set(dot, visual);
    });
  }

  function startEngagementWaveAnimation(state) {
    // Убедимся что волны включены и нет класса no-motion
    if (!ENGAGEMENT_CONFIG.wave.enabled || document.documentElement.classList.contains('no-motion')) {
      return;
    }

    const { circles, pattern } = state;
    
    const figureDots = circles.filter(dot => 
      dot.classList.contains('is-active') || 
      dot.classList.contains('is-filled') || 
      dot.classList.contains('is-strong')
    );

    if (figureDots.length === 0) return;

    const waveTimeline = gsap.timeline({
      repeat: -1,
      repeatDelay: ENGAGEMENT_CONFIG.wave.interval - ENGAGEMENT_CONFIG.wave.duration,
      paused: false // Сразу запускаем
    });

    if (pattern === "consulting-grid" || pattern === "growth-grid" || 
        pattern === "meaning-pillar-grid" || pattern === "growth-pillar-grid") {
      applyBottomToTopWave(waveTimeline, figureDots, state);
    } else if (pattern === "smart-speed-grid") {
      applyLeftToRightWave(waveTimeline, figureDots, state);
    } else if (pattern === "full-strategy-grid" || pattern === "strategy-pillar-grid") {
      applyCenterOutWave(waveTimeline, figureDots, state);
    } else if (pattern === "ongoing-partnership-grid") {
      applyCornersToCenterWave(waveTimeline, figureDots, state);
    }

    state.waveTimeline = waveTimeline;
  }

  function applyBottomToTopWave(timeline, dots, state) {
    const rowsMap = {};
    dots.forEach(dot => {
      const row = Number(dot.dataset.row);
      if (!rowsMap[row]) rowsMap[row] = [];
      rowsMap[row].push(dot);
    });

    const figureRows = Object.keys(rowsMap)
      .map(Number)
      .sort((a, b) => b - a);

    figureRows.forEach((row, index) => {
      const delay = (index / figureRows.length) * ENGAGEMENT_CONFIG.wave.duration;
      
      timeline.to(rowsMap[row], {
        backgroundColor: "rgba(255,0,55,0.6)",
        borderColor: "rgba(255,0,55,0.9)",
        scale: 1.15,
        duration: 0.15,
        ease: "power2.out"
      }, delay);

      timeline.to(rowsMap[row], {
        backgroundColor: (i, dot) => getDotVisualState(dot).backgroundColor,
        borderColor: (i, dot) => getDotVisualState(dot).borderColor,
        scale: 1,
        duration: 0.15,
        ease: "power2.in"
      }, delay + 0.2);
    });
  }

  function applyLeftToRightWave(timeline, dots, state) {
    const colsMap = {};
    dots.forEach(dot => {
      const col = Number(dot.dataset.col);
      if (!colsMap[col]) colsMap[col] = [];
      colsMap[col].push(dot);
    });

    const figureCols = Object.keys(colsMap)
      .map(Number)
      .sort((a, b) => a - b);

    figureCols.forEach((col, index) => {
      const delay = (index / figureCols.length) * ENGAGEMENT_CONFIG.wave.duration;
      
      timeline.to(colsMap[col], {
        backgroundColor: "rgba(255,0,55,0.6)",
        borderColor: "rgba(255,0,55,0.9)",
        scale: 1.15,
        duration: 0.15,
        ease: "power2.out"
      }, delay);

      timeline.to(colsMap[col], {
        backgroundColor: (i, dot) => getDotVisualState(dot).backgroundColor,
        borderColor: (i, dot) => getDotVisualState(dot).borderColor,
        scale: 1,
        duration: 0.15,
        ease: "power2.in"
      }, delay + 0.2);
    });
  }

  function applyCenterOutWave(timeline, dots, state) {
    const centerRow = (state.rows - 1) / 2;
    const centerCol = (state.cols - 1) / 2;

    const distanceMap = {};
    dots.forEach(dot => {
      const row = Number(dot.dataset.row);
      const col = Number(dot.dataset.col);
      const distance = Math.max(
        Math.abs(row - centerRow),
        Math.abs(col - centerCol)
      );
      if (!distanceMap[distance]) distanceMap[distance] = [];
      distanceMap[distance].push(dot);
    });

    const distances = Object.keys(distanceMap)
      .map(Number)
      .sort((a, b) => a - b);

    distances.forEach((distance, index) => {
      const delay = (index / distances.length) * ENGAGEMENT_CONFIG.wave.duration;
      
      timeline.to(distanceMap[distance], {
        backgroundColor: "rgba(255,0,55,0.6)",
        borderColor: "rgba(255,0,55,0.9)",
        scale: 1.15,
        duration: 0.15,
        ease: "power2.out"
      }, delay);

      timeline.to(distanceMap[distance], {
        backgroundColor: (i, dot) => getDotVisualState(dot).backgroundColor,
        borderColor: (i, dot) => getDotVisualState(dot).borderColor,
        scale: 1,
        duration: 0.15,
        ease: "power2.in"
      }, delay + 0.2);
    });
  }

  function applyCornersToCenterWave(timeline, dots, state) {
    const centerRow = (state.rows - 1) / 2;
    const centerCol = (state.cols - 1) / 2;

    const distanceMap = {};
    dots.forEach(dot => {
      const row = Number(dot.dataset.row);
      const col = Number(dot.dataset.col);
      
      const toCorners = [
        Math.sqrt(row * row + col * col),
        Math.sqrt(row * row + Math.pow(state.cols - 1 - col, 2)),
        Math.sqrt(Math.pow(state.rows - 1 - row, 2) + col * col),
        Math.sqrt(Math.pow(state.rows - 1 - row, 2) + Math.pow(state.cols - 1 - col, 2))
      ];
      const minDistance = Math.min(...toCorners);
      const roundedDistance = Math.round(minDistance * 10) / 10;
      
      if (!distanceMap[roundedDistance]) distanceMap[roundedDistance] = [];
      distanceMap[roundedDistance].push(dot);
    });

    const distances = Object.keys(distanceMap)
      .map(Number)
      .sort((a, b) => b - a);

    distances.forEach((distance, index) => {
      const delay = (index / distances.length) * ENGAGEMENT_CONFIG.wave.duration;
      
      timeline.to(distanceMap[distance], {
        backgroundColor: "rgba(255,0,55,0.6)",
        borderColor: "rgba(255,0,55,0.9)",
        scale: 1.15,
        duration: 0.15,
        ease: "power2.out"
      }, delay);

      timeline.to(distanceMap[distance], {
        backgroundColor: (i, dot) => getDotVisualState(dot).backgroundColor,
        borderColor: (i, dot) => getDotVisualState(dot).borderColor,
        scale: 1,
        duration: 0.15,
        ease: "power2.in"
      }, delay + 0.2);
    });
  }

  function startEngagementWaveAnimations() {
    engagementGrids.forEach((state) => {
      startEngagementWaveAnimation(state);
    });
  }

  function restoreDotBaseState(dot) {
    const visual = getDotVisualState(dot);

    gsap.set(dot, {
      backgroundColor: visual.backgroundColor,
      borderColor: visual.borderColor,
      scale: 1,
      opacity: visual.opacity,
      x: 0,
      y: 0
    });
  }

  function setupEngagementInteractions(state) {
    const { wrapper, circles } = state;

    // circles.forEach((dot) => {
    //   dot.addEventListener("mouseenter", () => {
    //     handleDotEnter(state, dot);
    //   });
    //   dot.addEventListener("mouseleave", () => {
    //     handleDotLeave(dot);
    //   });
    // });

    wrapper.addEventListener("mouseenter", () => {
      state.mouseInside = true;
    });

    wrapper.addEventListener("mouseleave", () => {
      state.mouseInside = false;
      if(wrapper.classList.contains('loaded')) {
        resetMagnetic(state);
      }
    });

    wrapper.addEventListener('mousemove', (e) => {
      if (!state.mouseInside) return;
      handleMagneticMove(state, e);
    });
    if (ENGAGEMENT_CONFIG.magnetic.enabled && wrapper && !document.documentElement.classList.contains('no-motion')) {
    }
  }

  // function handleDotEnter(state, dot) {
  // }

  // function handleDotLeave(dot) {
  // }

  function handleMagneticMove(state, event) {
    const { magnetic } = ENGAGEMENT_CONFIG;
    const { wrapper, circles } = state;
    if (!wrapper || !ENGAGEMENT_CONFIG.magnetic.enabled || document.documentElement.classList.contains('no-motion')) {
      return
    }

    const rect = wrapper.getBoundingClientRect();
    const mouseX = event.clientX - rect.left;
    const mouseY = event.clientY - rect.top;

    const baseSize = Math.min(rect.width, rect.height);
    const maxDist = baseSize * magnetic.maxDistanceRatio;

    circles.forEach((dot) => {
      const dotRect = dot.getBoundingClientRect();
      const cx = dotRect.left - rect.left + dotRect.width / 2;
      const cy = dotRect.top - rect.top + dotRect.height / 2;

      const dx = cx - mouseX;
      const dy = cy - mouseY;
      const dist = Math.sqrt(dx * dx + dy * dy) || 0.0001;

      if (dist > maxDist) {
        gsap.to(dot, {
          x: 0,
          y: 0,
          duration: magnetic.duration,
          ease: "power2.out",
          overwrite: "auto"
        });
        return;
      }

      const force = (maxDist - dist) / maxDist;
      const maxOffset = magnetic.maxOffset;
      const offsetX = (dx / dist) * force * maxOffset;
      const offsetY = (dy / dist) * force * maxOffset;

      gsap.to(dot, {
        x: offsetX,
        y: offsetY,
        duration: magnetic.duration,
        ease: "power2.out",
        overwrite: "auto"
      });
    });
  }

  function resetMagnetic(state) {
    const { magnetic } = ENGAGEMENT_CONFIG;
    const { circles } = state;

    circles.forEach((dot) => {
      gsap.to(dot, {
        x: 0,
        y: 0,
        duration: magnetic.duration,
        ease: "power2.out",
        overwrite: "auto",
        onComplete: () => {
          restoreDotBaseState(dot);
        }
      });
    });
  }

  function initEngagementAppearAnimations() {
    engagementGrids.forEach((state) => {
      const { wrapper, circles, pattern } = state;

      const prepareFromState = () => {
        circles.forEach((dot) => {
          const visual = getDotVisualState(dot);
          let offset = { x: 0, y: 0 };

          if (pattern === "consulting-grid") {
            offset = { x: -40, y: 20 };
          } else if (pattern === "full-strategy-grid") {
            offset = { x: -40, y: -40 };
          } else if (pattern === "ongoing-partnership-grid") {
            offset = { x: 0, y: 40 };
          } else if (pattern === "smart-speed-grid") {
            offset = { x: -60, y: 40 };
          } else if (pattern === "growth-grid") {
            offset = { x: -40, y: 20 };
          } else if (pattern === "strategy-pillar-grid") {
            offset = { x: -30, y: -30 };
          } else if (pattern === "meaning-pillar-grid") {
            offset = { x: 30, y: -30 };
          } else if (pattern === "growth-pillar-grid") {
            offset = { x: -30, y: 30 };
          }

          gsap.set(dot, {
            backgroundColor: visual.backgroundColor,
            borderColor: visual.borderColor,
            x: offset.x,
            y: offset.y,
            scale: 0.2,
            opacity: 0
          });
        });
      };

      const tl = gsap.timeline({ paused: true });

      tl.add(() => {
        if (state.waveTimeline) state.waveTimeline.pause(0);
        prepareFromState();
      });

      tl.to(circles, {
        x: 0,
        y: 0,
        scale: 1,
        opacity: (i, dot) => getDotVisualState(dot).opacity,
        duration: 0.7,
        ease: "back.out(1.6)",
        stagger: {
          each: 0.02,
          from: pattern === "smart-speed-grid" || pattern === "growth-grid" ? "edges" : "center"
        },
        onComplete: () => {
          if (state.waveTimeline && !document.documentElement.classList.contains('no-motion')) {
            state.waveTimeline.play();
          }
        }
      });

      tl.pause(0);
      // prepareFromState();
      // if (state.waveTimeline) state.waveTimeline.pause(0);
      state.appearTimeline = tl;

      const slide = wrapper.closest('.swiper-slide');
      if(slide) {
        console.log('has in slideshow')
        const mo = new MutationObserver(mutations => {
          mutations.forEach(m => {
            if (m.attributeName === 'class') {
              if (slide.classList.contains('has-animated')) {
                if(!wrapper.classList.contains('loaded')) {
                  wrapper.classList.add('loaded');
                  tl.restart(); 
                }
              }
            }
          });
        });
        mo.observe(slide, { attributes: true });
      } else {
        console.log('has no slideshow')
         ScrollTrigger.create({
          trigger: wrapper,
          start: "top 80%",
          onEnter: () => {
            if(!wrapper.classList.contains('loaded')) {
              wrapper.classList.add('loaded')
              tl.restart()
            }
          },
        });
      }

      
      
    //   const observer = new IntersectionObserver(
    //     (entries, obs) => {
    //       entries.forEach((entry) => {
    //         if (!entry.isIntersecting) return;
    //         if(!entry.target.classList.contains('loaded') && entry.target.closest('.swiper-slide-active')) {
    //             tl.restart();
    //             entry.target.classList.add('loaded');
    //           }
    //         obs.unobserve(wrapper);
    //       });
    //     },
    //     { threshold: 0.1 }
    //   );

    // observer.observe(wrapper);
    });
  }
  export function cleanup() {
    engagementGrids.forEach(state => {
      if (state.waveTimeline) state.waveTimeline.kill();
      if (state.appearTimeline) state.appearTimeline.kill();
    });
    
    if (waveAnimation) waveAnimation.kill();
    clearTimeout(waveTimeout);
  }
